import { render, staticRenderFns } from "./FocusedClientCategory.vue?vue&type=template&id=3c323e88&scoped=true"
import script from "./FocusedClientCategory.vue?vue&type=script&lang=js"
export * from "./FocusedClientCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c323e88",
  null
  
)

export default component.exports